import { render } from "./ModalHistoriaDetalle.vue?vue&type=template&id=1425015b&scoped=true"
import script from "./ModalHistoriaDetalle.vue?vue&type=script&lang=js"
export * from "./ModalHistoriaDetalle.vue?vue&type=script&lang=js"

import "./ModalHistoriaDetalle.vue?vue&type=style&index=0&id=1425015b&scoped=true&lang=css"

import exportComponent from "/home/usuario/Proyectos/2025/ArkhamHorror/App_Arkham_Horror_3/multigames/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1425015b"]])

export default __exports__